module.exports = __webpack_public_path__ + "img/xiaomi-4.9006d0ca.png";